import React from "react";
import { Link, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import LeadsTenant from "./pages/LeadsTenant";
import LeadsLandlord from "./pages/LeadsLandlord";
import DebugApi from "./pages/DebugApi";
import PortalStub from "./pages/PortalStub";

export default function App() {
  return (
    <div className="container">
      <div className="nav">
        <Link to="/">Home</Link>
        <Link to="/crm">/crm</Link>
        <Link to="/admin">/admin</Link>
        <Link to="/tenant">/tenant</Link>
        <Link to="/owner">/owner</Link>
        <span className="muted">|</span>
        <Link to="/leads/tenant">租客线索</Link>
        <Link to="/leads/landlord">业主线索</Link>
        <span className="muted">|</span>
        <Link to="/debug">API Debug</Link>
      </div>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/leads/tenant" element={<LeadsTenant />} />
        <Route path="/leads/landlord" element={<LeadsLandlord />} />
        <Route path="/debug" element={<DebugApi />} />

        {/* 五端占位（后续可拆成真实页面） */}
        <Route path="/crm" element={<PortalStub name="CRM" />} />
        <Route path="/admin" element={<PortalStub name="Admin" />} />
        <Route path="/tenant" element={<PortalStub name="Tenant" />} />
        <Route path="/owner" element={<PortalStub name="Owner" />} />

        {/* SPA 默认兜底 */}
        <Route path="*" element={<Home />} />
      </Routes>
    </div>
  );
}
